/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import https from 'https';
import getConfig from '../../config';
import uuid from 'uuid';
declare let adobeIMS: AdobeIMS;

class SupportService {
	/*
	 **
	 **  P U B L I C   I N T E R F A C E
	 **
	 */
	fetchAssetRef(assetId) {
		return this._performAssetRefFetch(assetId);
	}

	/*
	 **
	 **  P R I V A T E   M E T H O D S
	 **
	 */
	static instance: SupportService;

	// $FlowFixMe
	constructor() {
		if (!SupportService.instance) {
			SupportService.instance = this;
		}
		return SupportService.instance;
	}

	_performAssetRefFetch(assetId): Promise<any> {
		return new Promise((resolve, reject) => {
			const {hostname, assetsPath} = getConfig('SERVICES').supportServer;

			const obj = {
				hostname,
				path: `${assetsPath}${assetId}/asset-ref`,
				method: 'GET',
				headers: {
					Authorization: `Bearer ${adobeIMS.getAccessToken()}`,
					'x-api-key': 'CCHomeWeb1',
					'x-request-id': uuid.v4(),
					'Accept-Language': 'en',
					'Content-Type': 'application/json',
				},
				dataType: 'json',
				withCredentials: false,
			};
			const request = https.request(obj, (res) => {
				// Report status to the user content store
				if (res.statusCode && res.statusCode !== 200) {
					window.cchome.util.logger.error('SupportService', 'Problem with Asset Ref request', res);
					reject(new Error('SupportService error'));
				}
				else {
					let data = '';
					// set the encoding to UTF8 to prevent decoding issues on certain browsers.
					// https://jira.corp.adobe.com/browse/CCH-4427
					res.setEncoding('utf8');
					res.on('data', chunk => (data += chunk));
					res.on('end', () => {
						// Success!
						try {
							resolve(JSON.parse(data));
						}
						catch (e: any) {
							window.cchome.util.logger.error(
								'Support Service',
								'Problem with parsing SupportService response',
								e.toString(),
							);
							reject(new Error('SupportService parse error'));
						}
					});
				}
			});

			request.on('error', (err) => {
				// There was a connection error of some sort
				window.cchome.util.logger.error(
					'Support Service',
					'Problem with SupportService request',
					err.toString(),
				);
				reject(new Error('SupportService error'));
			});
			request.end();
		});
	}
}

export default SupportService;
